import React from 'react';
import classNames from 'classnames';
import { ExternalLink } from '../../../components';
import { getSignatureServices } from './ExploreServices';
import SectionAutographs from './SectionAutographs';
import SectionShoutouts from './SectionShoutouts';
import SectionEndorsements from './SectionEndorsements';
import SectionAppearances from './SectionAppearances';
import SectionTalentPlus from './SectionTalentPlus';
import SectionExclusedTraining from './SectionExclusedTraining';
import MembershipSection from './MembershipSection';
import BusinessDevelopment from './BusinessDevelopment';
import ContentCreation from './ContentCreation';
import SocialMediaSection from './SocialMediaSection';
import CustomEnahncedServices from './CustomEnahncedServices';

import css from './Sections.module.css';
import '../../../styles/slick/slick.css';
import '../../../styles/slick/slick-theme.css';
import SectionCreativeMedia from './SectionCreativeMedia';

function SectionProfile(props) {
  const { intl, listing, providerServices, selectedService, isTalentProfileModalContent } = props;

  const { publicData = {}, title = '' } = listing?.attributes || {};

  const selectedSignatureService = getSignatureServices(intl)?.find(
    s => s?.key === selectedService
  );

  const talentPlusMaybe = publicData?.talentPlus;
  const serviceComponents = {
    autographs: SectionAutographs,
    shoutouts: SectionShoutouts,
    endorsements: SectionEndorsements,
    appearances: SectionAppearances,
    creativeMedia: SectionCreativeMedia,
    exclusiveTraining: SectionExclusedTraining,
    mentorship: MembershipSection,
    businessDevelopment: BusinessDevelopment,
    contentCreation: ContentCreation,
    socialMedia: SocialMediaSection,
    customService: CustomEnahncedServices,
  };

  const RenderSelectedSection = serviceComponents[selectedService];
  return (
    <div
      className={classNames(
        isTalentProfileModalContent ? css.talentProfileModalContent : null,
        css.SectionProfile
      )}
    >
      <div className={css.contentWidth}>
        {/* {isArrayLength(profileVideos) && (
          <div className={css.templatesSlider}>
            <Slider {...{ ...sliderSettings, arrows: !isMobileLayout }}>
              {isArrayLength(profileVideos) &&
                profileVideos?.map((step, index) => (
                  <Step
                    key={index}
                    step={step}
                    onRedirect={() => useHistoryPush(step.linkDestination)}
                  />
                ))}
            </Slider>
          </div>
        )} */}

        {selectedService && (
          <RenderSelectedSection
            selectedSignatureService={selectedSignatureService}
            providerServices={providerServices}
            title={title}
            intl={intl}
            talentPlus={talentPlusMaybe}
            listing={listing}
          />
        )}
        {/* {talentPlusMaybe ? <SectionTalentPlus talentPlusMaybe={talentPlusMaybe} /> : null} */}
      </div>
    </div>
  );
}
// Default slider settings
const sliderSettings = {
  dots: false,
  arrows: true,
  infinite: false,
  autoplay: false,
  autoplaySpeed: 2000,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1128,
      settings: {
        slidesToShow: 3,
        variableWidth: false,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        variableWidth: false,
      },
    },
    {
      breakpoint: 767,
      settings: {
        centerMode: true,
        slidesToShow: 1,
        variableWidth: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: true,
        slidesToShow: 1,
        variableWidth: false,
      },
    },
  ],
};
SectionProfile.defaultProps = {
  sliderSettings,
};
export default SectionProfile;
